// TODO: resolve CHCP disables by bot
// eslint-disable-next-line max-classes-per-file
import { Action } from '@ngrx/store';
import {
  ClaimsSearchCriteria,
  ClaimsSearchResponse,
  ClaimsReferSearchCriteria,
  ClaimDetails,
  RemittanceDetailsResponse,
  RemittanceRead,
  RemittanceReadResponse,
  ClaimTabType,
  ServiceLineInfo,
  Adjustment,
  DetailRequest,
} from '@cigna/chcp/claims/shared/util';
import { ProviderByTin } from '@cigna/chcp/shared/provider-data-access';
import {
  ServiceError,
  AttachmentMetaData,
  FileWithUrl,
  AttachmentToUpload,
  SupportingInformation,
  Attachment,
  ReconsiderationType,
} from '@cigna/chcp/shared/util';
import { FlaggedClaim } from '@cigna/chcp/shared/user-profile-data-access';

export enum ClaimsSearchActionTypes {
  ResetSearch = '[ClaimsSearch] Reset Search',
  ResetSearchStage = '[ClaimsSearch] Reset Search Stage',
  NewSearch = '[ClaimsSearch] New Search',
  ModifySearch = '[ClaimsSearch] Modify Search',
  SearchClaims = '[ClaimsSearch] Search Claims',
  SearchClaimsError = '[ClaimsSearch] Search Claims Error',
  SearchClaimsSuccess = '[ClaimsSearch] Search Claims Success',
  ClaimsNumberSearch = '[ClaimsSearch] Claims Number Search',
  ClaimsNumberSearchError = '[ClaimsSearch] Claims Number Search Error',
  ClaimsNumberSearchSuccess = '[ClaimsSearch] Claims Number Search Success',
  TabSelection = '[ClaimsSearch] Tab Selection',
  DisplayClaimsDetails = '[ClaimsSearch] Display Claims Details',
  LoadClaimsDetailsSuccess = '[ClaimsSearch] Load Claims Details Success',
  LoadClaimsDDARSuccess = '[ClaimsSearch] Load Claims DDAR Success',
  LoadClaimsDetailsError = '[ClaimsSearch] Load Claims Details Error',
  MultiplePatients = '[ClaimsSearch] Multiple Patients Submit',
  MultiplePatientsSuccess = '[ClaimsSearch] Multiple Patients Submit Success',
  BackToMultiplePatients = '[ClaimsSearch] Back To Multiple Patients',
  RemittanceReadStatus = '[ClaimsSearch] Remittance Report Read Status',
  RemittanceReadStatusSuccess = '[ClaimsSearch] Remittance Report Read Status Success',
  RemittanceReadStatusError = '[ClaimsSearch] Remittance Report Read Status Error',
  FetchSupplementaryClaimInfo = '[ClaimsSearch] Fetch Supplementary Claim Info',
  FetchAdjustments = '[Reconsideration] Fetch Adjustments',
  FetchAdjustmentsSuccess = '[Reconsideration] Fetch Adjustments Success',
  FetchAdjustmentsError = '[Reconsideration] Fetch Adjustments Error',
  RemoveAdjustment = '[Reconsideration] Remove Adjustment',
  RemoveAdjustmentSuccess = '[Reconsideration] Remove Adjustment Success',
  RemoveAdjustmentError = '[Reconsideration] Remove Adjustment Error',
  ReconsiderationStart = '[Reconsideration] Reconsideration Start',
  SetIsReconsiderationHistoryOpened = '[ClaimsSearch] Set Is Adjustment History Tab Opened',
  SetSupportingInformationTabOpened = '[ClaimsSearch] Set Is Supporting Information Tab Opened',
  SetHistoryDataIndex = '[ClaimsSearch] Set History Data Index',
  ResetReconsiderationInfo = '[ClaimsSearch] Reset Reconsideration Data',
  GetProviderByTin = '[ClaimsSearch] Get Provider Name By Tin',
  GetProviderByTinSuccess = '[ClaimsSearch] Get Provider Name By Tin Success',
  GetProviderByTinError = '[ClaimsSearch] Get Provider Name By Tin Error',
  SaveStartAReconsiderationData = '[ClaimsSearch] Save Start A Reconsideration Data',
  UploadAttachments = '[ClaimsSearch] Upload Attachments',
  GetAttachmentsSignedUrlToPutFile = '[ClaimsSearch] Get Attachments Signed Url To Put File',
  GetAttachmentsSignedUrlToPutFileSuccess = '[ClaimsSearch] Get Attachments Signed Url To Put File Success',
  GetAttachmentsSignedUrlToPutFileFailed = '[ClaimsSearch] Get Attachments Signed Url To Put File Failed',
  PutFileToS3Success = '[ClaimsSearch] Put File To S3 Success',
  PutFileToS3Failed = '[ClaimsSearch] Put File To S3 Failed',
  FileToS3UploadProgress = '[ClaimsSearch] File To S3 Upload Progress',
  GetAttachmentDetailsForUploadedSuccess = '[ClaimsSearch] Get Attachment Details For Uploaded Success',
  GetAttachmentDetailsForUploadedFailed = '[ClaimsSearch] Get Attachment Details For Uploaded Failed',
  AttachmentClick = '[ClaimsSearch] Attachment Click',
  RemoveAttachment = '[ClaimsSearch] Remove Attachment',
  RemoveAttachmentSuccess = '[ClaimsSearch] Remove Attachment Success',
  RemoveAttachmentFailed = '[ClaimsSearch] Remove Attachment Failed',
  SubmitSupportingInformation = '[ClaimsSearch] Submit Supporting Information',
  SubmitSupportingInformationSuccess = '[ClaimsSearch] Submit Supporting Information Success',
  SubmitSupportingInformationFailed = '[ClaimsSearch] Submit Supporting Information Failed',
  GetSupportingInformationHistory = '[ClaimsSearch] Get Supporting Information History',
  GetSupportingInformationHistorySuccess = '[ClaimsSearch] Get Supporting Information History Success',
  GetSupportingInformationHistoryFailed = '[ClaimsSearch] Get Supporting Information History Failed',
  GetSupportingInformationAttachments = '[ClaimsSearch] Get Supporting Information Attachments',
  GetSupportingInformationAttachmentsSuccess = '[ClaimsSearch] Get Supporting Information Attachments Success',
  GetSupportingInformationAttachmentsFailed = '[ClaimsSearch] Get Supporting Information Attachments Failed',
  SetSupportingInfoSubmissionNumber = '[ClaimsSearch] Set Supporting Info Submission Number',
  SetSelectedServiceLine = '[ClaimsSearch] Set Selected Service Line',
  RemoveSelectedServiceLine = '[ClaimsSearch] Remove Selected Service Line',
}

export class ResetSearch implements Action {
  readonly type = ClaimsSearchActionTypes.ResetSearch;
}

export class ResetSearchStage implements Action {
  readonly type = ClaimsSearchActionTypes.ResetSearchStage;
}

export class NewSearch implements Action {
  readonly type = ClaimsSearchActionTypes.NewSearch;
}

export class ModifySearch implements Action {
  readonly type = ClaimsSearchActionTypes.ModifySearch;
}

export class TabSelection implements Action {
  readonly type = ClaimsSearchActionTypes.TabSelection;
  constructor(public payload: ClaimTabType) {}
}

export class SearchClaims implements Action {
  readonly type = ClaimsSearchActionTypes.SearchClaims;
  constructor(public payload: ClaimsSearchCriteria) {}
}

export class SearchClaimsSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.SearchClaimsSuccess;
  constructor(public payload: ClaimsSearchResponse) {}
}

export class SearchClaimsError implements Action {
  readonly type = ClaimsSearchActionTypes.SearchClaimsError;
  constructor(public payload: ServiceError) {}
}

export class FetchAdjustments implements Action {
  readonly type = ClaimsSearchActionTypes.FetchAdjustments;
  constructor(public payload: { claimReferenceNumber: string }) {}
}

export class FetchSupplementaryClaimInfo implements Action {
  readonly type = ClaimsSearchActionTypes.FetchSupplementaryClaimInfo;
}

export class FetchAdjustmentsSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.FetchAdjustmentsSuccess;
  constructor(public payload: Adjustment[]) {}
}

export class FetchAdjustmentsError implements Action {
  readonly type = ClaimsSearchActionTypes.FetchAdjustmentsError;
  constructor(public payload: ServiceError) {}
}

export class RemoveAdjustment implements Action {
  readonly type = ClaimsSearchActionTypes.RemoveAdjustment;
  constructor(public payload: { id: string; reconType: ReconsiderationType }) {}
}

export class RemoveAdjustmentSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.RemoveAdjustmentSuccess;
  constructor(public payload: { id: string }) {}
}

export class RemoveAdjustmentError implements Action {
  readonly type = ClaimsSearchActionTypes.RemoveAdjustmentError;
  constructor(public payload: ServiceError) {}
}

export class SetIsReconsiderationHistoryOpened implements Action {
  readonly type = ClaimsSearchActionTypes.SetIsReconsiderationHistoryOpened;
  constructor(public payload: boolean) {}
}

export class ResetReconsiderationInfo implements Action {
  readonly type = ClaimsSearchActionTypes.ResetReconsiderationInfo;
}

export class SetSupportingInformationTabOpened implements Action {
  readonly type = ClaimsSearchActionTypes.SetSupportingInformationTabOpened;
  constructor(public payload: boolean) {}
}

export class ClaimsNumberSearch implements Action {
  readonly type = ClaimsSearchActionTypes.ClaimsNumberSearch;
  constructor(public payload: ClaimsReferSearchCriteria) {}
}

export class ClaimsNumberSearchSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.ClaimsNumberSearchSuccess;
  constructor(public payload: ClaimsSearchResponse) {}
}

export class ClaimsNumberSearchError implements Action {
  readonly type = ClaimsSearchActionTypes.ClaimsNumberSearchError;
  constructor(public payload: ServiceError) {}
}

export class DisplayClaimsDetails implements Action {
  readonly type = ClaimsSearchActionTypes.DisplayClaimsDetails;
  constructor(public payload: DetailRequest) {}
}

export class LoadClaimsDetailsSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.LoadClaimsDetailsSuccess;
  constructor(public payload: ClaimDetails) {}
}

export class LoadClaimsDDARSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.LoadClaimsDDARSuccess;
  constructor(
    public payload: {
      claimDetailsResponse: ClaimDetails;
      remittanceDetailsResponse: RemittanceDetailsResponse;
    },
  ) {}
}

export class LoadClaimsDetailsError implements Action {
  readonly type = ClaimsSearchActionTypes.LoadClaimsDetailsError;
  constructor(public payload: ServiceError) {}
}

export class MultiplePatients implements Action {
  readonly type = ClaimsSearchActionTypes.MultiplePatients;
  constructor(
    public payload: ClaimsSearchCriteria,
    public flaggedData?: FlaggedClaim,
  ) {}
}

export class MultiplePatientsSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.MultiplePatientsSuccess;
  constructor(public payload: ClaimsSearchResponse) {}
}

export class BackToMultiplePatients implements Action {
  readonly type = ClaimsSearchActionTypes.BackToMultiplePatients;
}
export class RemittanceReadStatus implements Action {
  readonly type = ClaimsSearchActionTypes.RemittanceReadStatus;
  constructor(public payload: RemittanceRead) {}
}

export class RemittanceReadStatusSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.RemittanceReadStatusSuccess;
  constructor(public payload: RemittanceReadResponse) {}
}

export class RemittanceReadStatusError implements Action {
  readonly type = ClaimsSearchActionTypes.RemittanceReadStatusError;
  constructor(public payload: ServiceError) {}
}

export class SetHistoryDataIndex implements Action {
  readonly type = ClaimsSearchActionTypes.SetHistoryDataIndex;
  constructor(public payload: number) {}
}
export class GetProviderByTin implements Action {
  readonly type = ClaimsSearchActionTypes.GetProviderByTin;
  constructor(public payload: string) {}
}

export class GetProviderByTinSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.GetProviderByTinSuccess;
  constructor(public payload: ProviderByTin[]) {}
}
export class GetProviderByTinError implements Action {
  readonly type = ClaimsSearchActionTypes.GetProviderByTinError;
  constructor(public error: ServiceError) {}
}
export class SaveStartAReconsiderationData implements Action {
  readonly type = ClaimsSearchActionTypes.SaveStartAReconsiderationData;
  constructor(public payload: Partial<Adjustment>) {}
}

export class GetSupportingInformationHistory implements Action {
  readonly type = ClaimsSearchActionTypes.GetSupportingInformationHistory;
  constructor(
    public payload: {
      claimReferenceNumber: string;
      sourceSystemCode: string;
      claimEngineClaimID: string;
    },
  ) {}
}

export class GetSupportingInformationHistorySuccess implements Action {
  readonly type =
    ClaimsSearchActionTypes.GetSupportingInformationHistorySuccess;
  constructor(public payload: SupportingInformation[]) {}
}

export class GetSupportingInformationHistoryFailed implements Action {
  readonly type = ClaimsSearchActionTypes.GetSupportingInformationHistoryFailed;
  constructor(public error: ServiceError) {}
}

export class GetSupportingInformationAttachments implements Action {
  readonly type = ClaimsSearchActionTypes.GetSupportingInformationAttachments;
  constructor(public payload: { id: string; attachmentIds: string[] }) {}
}

export class GetSupportingInformationAttachmentsSuccess implements Action {
  readonly type =
    ClaimsSearchActionTypes.GetSupportingInformationAttachmentsSuccess;
  constructor(
    public payload: { id: string; attachments: AttachmentMetaData[] },
  ) {}
}

export class GetSupportingInformationAttachmentsFailed implements Action {
  readonly type =
    ClaimsSearchActionTypes.GetSupportingInformationAttachmentsFailed;
  constructor(public error: ServiceError) {}
}

export class UploadAttachments implements Action {
  readonly type = ClaimsSearchActionTypes.UploadAttachments;
  constructor(public payload: FileWithUrl[]) {}
}

export class GetAttachmentsSignedUrlToPutFile implements Action {
  readonly type = ClaimsSearchActionTypes.GetAttachmentsSignedUrlToPutFile;
  constructor(public payload: FileWithUrl[]) {}
}

export class GetAttachmentsSignedUrlToPutFileSuccess implements Action {
  readonly type =
    ClaimsSearchActionTypes.GetAttachmentsSignedUrlToPutFileSuccess;
  constructor(public payload: AttachmentToUpload[]) {}
}

export class GetAttachmentsSignedUrlToPutFileFailed implements Action {
  readonly type =
    ClaimsSearchActionTypes.GetAttachmentsSignedUrlToPutFileFailed;
  constructor(public payload: { fileNames: string[]; error: ServiceError }) {}
}

export class PutFileToS3Success implements Action {
  readonly type = ClaimsSearchActionTypes.PutFileToS3Success;
  constructor(public payload: AttachmentToUpload) {}
}

export class PutFileToS3Failed implements Action {
  readonly type = ClaimsSearchActionTypes.PutFileToS3Failed;
  constructor(public payload: { fileNames: string[]; error: ServiceError }) {}
}

export class FileToS3UploadProgress implements Action {
  readonly type = ClaimsSearchActionTypes.FileToS3UploadProgress;
  constructor(public payload: AttachmentToUpload) {}
}

export class GetAttachmentDetailsForUploadedSuccess implements Action {
  readonly type =
    ClaimsSearchActionTypes.GetAttachmentDetailsForUploadedSuccess;
  constructor(public payload: AttachmentMetaData) {}
}

export class GetAttachmentDetailsForUploadedFailed implements Action {
  readonly type = ClaimsSearchActionTypes.GetAttachmentDetailsForUploadedFailed;
  constructor(public payload: { fileNames: string[]; error: ServiceError }) {}
}

export class AttachmentClick implements Action {
  readonly type = ClaimsSearchActionTypes.AttachmentClick;
  constructor(public payload: Attachment) {}
}

export class RemoveAttachment implements Action {
  readonly type = ClaimsSearchActionTypes.RemoveAttachment;
  constructor(public payload: string) {}
}

export class RemoveAttachmentSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.RemoveAttachmentSuccess;
  constructor(public payload: string) {}
}

export class RemoveAttachmentFailed implements Action {
  readonly type = ClaimsSearchActionTypes.RemoveAttachmentFailed;
  constructor(public error: ServiceError) {}
}

export class SubmitSupportingInformation implements Action {
  readonly type = ClaimsSearchActionTypes.SubmitSupportingInformation;
}

export class SubmitSupportingInformationSuccess implements Action {
  readonly type = ClaimsSearchActionTypes.SubmitSupportingInformationSuccess;
  constructor(public payload: SupportingInformation) {}
}

export class SubmitSupportingInformationFailed implements Action {
  readonly type = ClaimsSearchActionTypes.SubmitSupportingInformationFailed;
  constructor(public error: ServiceError) {}
}

export class SetSupportingInfoSubmissionNumber implements Action {
  readonly type = ClaimsSearchActionTypes.SetSupportingInfoSubmissionNumber;
  constructor(public payload: string) {}
}

export class SetSelectedServiceLine implements Action {
  readonly type = ClaimsSearchActionTypes.SetSelectedServiceLine;
  constructor(public payload: ServiceLineInfo) {}
}

export class RemoveSelectedServiceLine implements Action {
  readonly type = ClaimsSearchActionTypes.RemoveSelectedServiceLine;
  constructor(public payload: number) {}
}

export type ClaimsSearchAction =
  | ResetSearch
  | ResetSearchStage
  | NewSearch
  | ModifySearch
  | TabSelection
  | SearchClaims
  | SearchClaimsSuccess
  | SearchClaimsError
  | ClaimsNumberSearch
  | ClaimsNumberSearchSuccess
  | ClaimsNumberSearchError
  | DisplayClaimsDetails
  | LoadClaimsDetailsSuccess
  | LoadClaimsDDARSuccess
  | LoadClaimsDetailsError
  | MultiplePatients
  | MultiplePatientsSuccess
  | BackToMultiplePatients
  | RemittanceReadStatus
  | RemittanceReadStatusSuccess
  | RemittanceReadStatusError
  | FetchSupplementaryClaimInfo
  | FetchAdjustments
  | FetchAdjustmentsSuccess
  | FetchAdjustmentsError
  | RemoveAdjustment
  | RemoveAdjustmentSuccess
  | RemoveAdjustmentError
  | SetIsReconsiderationHistoryOpened
  | SetSupportingInformationTabOpened
  | SetHistoryDataIndex
  | ResetReconsiderationInfo
  | GetProviderByTin
  | GetProviderByTinSuccess
  | GetProviderByTinError
  | SaveStartAReconsiderationData
  | UploadAttachments
  | GetAttachmentsSignedUrlToPutFile
  | GetAttachmentsSignedUrlToPutFileSuccess
  | GetAttachmentsSignedUrlToPutFileFailed
  | PutFileToS3Success
  | PutFileToS3Failed
  | FileToS3UploadProgress
  | GetAttachmentDetailsForUploadedSuccess
  | GetAttachmentDetailsForUploadedFailed
  | SubmitSupportingInformation
  | SubmitSupportingInformationSuccess
  | SubmitSupportingInformationFailed
  | GetSupportingInformationHistory
  | GetSupportingInformationHistorySuccess
  | GetSupportingInformationHistoryFailed
  | GetSupportingInformationAttachments
  | GetSupportingInformationAttachmentsSuccess
  | GetSupportingInformationAttachmentsFailed
  | SetSupportingInfoSubmissionNumber
  | AttachmentClick
  | RemoveAttachment
  | RemoveAttachmentSuccess
  | RemoveAttachmentFailed
  | SetSelectedServiceLine
  | RemoveSelectedServiceLine;
